/**
 * 1. geçiş — seyrek tarama.
 *
 * Küçük hedefe çizilir: her texel ekrandaki bir hücreye (stride × stride piksel) denk gelir.
 * Her kare hücrenin içindeki başka bir piksel taranır (`_sampleOffset`, Bayer sırası);
 * stride 4'te 16 karede hücrenin 16 pikselinin hepsi taranmış olur.
 *
 * Çıktı (hücre başına): vec4( gi.rgb, ao ). Taranan piksel gökyüzüyse alfa = NO_DATA.
 */

import { Fn, If, floor, min, uv, vec4 } from 'three/tsl';
import { buildHorizonTrace } from './horizonTrace.js';
import { NO_DATA, readSurface } from './screenSurface.js';

/** Hücrenin bu kare taranan pikseli (doldurma geçişi de aynı formülü kullanır). */
export function cellSamplePixel( node, cell ) {

	return min( cell.mul( node._stride ).add( node._sampleOffset ), node._fullResolution.sub( 1 ) );

}

export function buildTracePass( node ) {

	const traceGiAo = buildHorizonTrace( node );

	return Fn( () => {

		const cell = floor( uv().mul( node._cellResolution ) );
		const pixelCenter = cellSamplePixel( node, cell ).add( 0.5 );
		const screenUv = pixelCenter.div( node._fullResolution );

		const result = vec4( 0, 0, 0, NO_DATA ).toVar();

		If( readSurface( node, screenUv ).isSky.not(), () => {

			result.assign( traceGiAo( screenUv, pixelCenter ) );

		} );

		return result;

	} )();

}
